import common from './common';

const IFrameOrigin = common.getIframeOrigin();
const isWindowDefined = common.isWindowDefined;

const DEFAULTERROR = {
  resultStatus: 'F',
  resultCode: '500',
  resultMsg: 'Something went wrong...'
};

const postMessageCall = info => {
  try {
    isWindowDefined &&
      window &&
      window.parent &&
      window.parent.postMessage &&
      window.parent.postMessage(info, IFrameOrigin);
    common.log('POST_MESSAGE', 'success', { info });
  } catch (err) {
    common.log('POST_MESSAGE', 'error', { err });
  }
};

export const postMessageOnParentWindow = response => {
  if (
    response &&
    response.hasOwnProperty('body') &&
    response.body &&
    response.body.hasOwnProperty('resultInfo') &&
    response.body.resultInfo
  ) {
    postMessageCall(response.body.resultInfo);
  } else if (!response || !response.body || !response.body.resultInfo) {
    postMessageCall(DEFAULTERROR);
  }
};

/**
 * post the scroll height to `UMP`
 */

export const postScrollHeight = () => {
  if (isWindowDefined && document && document.getElementById) {
    const app = document.getElementById('app');
    try {
      const postMessageObj = {
        body: { resultInfo: { resultCode: '005', height: app.scrollHeight } }
      };
      // 005 code is used to pass the scrollHeight to UMP
      postMessageOnParentWindow(postMessageObj);
    } catch (err) {
      //
    }
  }
};




// WEBPACK FOOTER //
// ./common/postMessage.js